import React from "react";

import { Doc } from "affinityUI/structures/doc";

import LoginPage from "./assets/Login page.png";
import RegistrationEmail from "./assets/Registration email.png";
import PasswordSet from "./assets/Set password confirmation.png";
import setPassword from "./assets/Set password.png";

export const RegistrationSection: React.FC = () => {
  return (
    <Doc.Section title="Registration">
      <p>
        Once you have shared your email address, Entia will register your user profile allow to access to the
        application. During the registration, an email will be sent to the provided email address. You will need to
        follow the instructions within the registration email once it has been received.
      </p>
      <Doc.Illustration src={RegistrationEmail} label="Registration email" />
      <p>
        You will need to scan the QR code in the registration email with the tablet provided by Entia. After this, the
        Set Password page will be opened in the browser on the tablet.
      </p>
      <Doc.Illustration src={setPassword} label="Form page" />
      <p>
        The Login page will be opened once the “Login” button is pressed. Once you have entered your email and password,
        press the “Login” button to enter the Entia Liberty Dashboard.
      </p>
      <Doc.Illustration src={PasswordSet} label="Password set confirmation" />
      <p>
        You will need to enter a password which you will use to log in to the Entia Liberty Dashboard. After you set up
        the password and press the “Set password” button, which will lead you to the confirmation page.
      </p>
      <Doc.Illustration src={LoginPage} label="Login page" />
    </Doc.Section>
  );
};
